import React from 'react'

import './title.scss'


function Title() {
  
  return (
    <div className="title__wrapper">
        <div className="title">
            wallpapers
        </div>
    </div>
  );
}

export default Title;
